import { encryptFileAES } from "./OstreonEncryption";
import { sendUIErrorToBackend } from "./sendErrorToBackend";
import { base64toFile } from "./UploadFile";
import config from "../config";
const base_url = config?.base_url
export const detectRedirectionPage = (authData) => {
  const nextPage = localStorage.getItem("redirection_page");
  const hasInitialProduct = localStorage.getItem("registration_product");

  if (nextPage) {
    let path =
      nextPage === "plan" || hasInitialProduct
        ? "user/plan?welcome=true"
        : nextPage === "dashboard"
        ? "user/dashboard"
        : "user/dashboard";

    window.location.assign(`${window?.location?.origin}/${path}`);
  } else {
    const path = authData?.webinar
      ? "user/plan?welcome=true"
      : "user/dashboard";
    window.location.assign(`${window?.location?.origin}/${path}`);
  }
};
export const prepareUserFetch = (handle_redirection, userData, redirection_on_error) =>{
  fetch(base_url + "user/prepare/data/user", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
  })
  .then((res) => {
    if (res.status === 302) {
      handle_redirection();
    } else return res?.json();
  })
  .then(async (data) => {
    if (!data) return;
    const { legal, trustee } = data;
    let trustee_id;
    if (trustee) {
      const trustee_index = isNaN(
        Number(userData?.UserData?.trustees?.filter(e=>e?.editable==true)?.length)
      )
        ? 1
        : Number(userData?.UserData?.trustees?.filter(e=>e?.editable==true)?.length) + 1;
      trustee_id = `${userData?.UserData?.user_id}-T${trustee_index}`;
    }
    if (legal && legal?.profile_avatar) {
      const image = base64toFile(legal?.profile_avatar);
      const formData = new FormData();
      const private_key = userData?.private_key;
      const encrypted_image = await encryptFileAES(private_key, image);
      formData.append("file", encrypted_image);
      formData.append("profile_id", legal?.user_id);
      fetch(base_url + "user/profile/pic/upload", {
        method: "POST",
        mode: "cors",
        body: formData,
        credentials: "include",
      });
    }
    if (trustee && trustee?.profile_avatar) {
      const image = base64toFile(trustee?.profile_avatar);
      const formData = new FormData();
      const private_key = userData?.private_key;
      const encrypted_image = await encryptFileAES(private_key, image);
      formData.append("file", encrypted_image);
      formData.append("profile_id", trustee_id);
      fetch(base_url + "user/profile/pic/upload", {
        method: "POST",
        mode: "cors",
        body: formData,
        credentials: "include",
      });
    }

    if (legal && trustee) {
      userData.setUserData({
        ...userData.UserData,
        legal: [legal],
        trustees: [
          ...userData?.UserData?.trustees.filter(e=>e?.editable==true),
          { ...trustee, editable: false, user_id: trustee_id },
        ],
      });
    } else if (trustee) {
      userData.setUserData({
        ...userData.UserData,
        trustees: [
          ...userData?.UserData?.trustees.filter(e=>e?.editable==true),
          { ...trustee, editable: false, user_id: trustee_id },
        ],
      });
    } else if (legal) {
      userData.setUserData({
        ...userData.UserData,
        legal: [legal],
      });
    }
    setTimeout(() => {
      handle_redirection();
    }, 2000);

    //We need to
    // 1. Upload the profile avatars to trustees and beneficiaries
    // 2. Upoad the Asset Files and Beneficiary documents
    // 3. Create the beneficiaries accounts
    // const {assets, beneficiaries, trustees, legal} = data
  })
  .catch((err) => {
    console.log(err);
    sendUIErrorToBackend(err);
    redirection_on_error()
    // window.location.assign(
    //   `${window?.location?.protocol}//${window?.location?.host}/user/dashboard`
    // );
  });
}
